// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ROOT VARIABLES
 * Define common values for easy maintenance.
 */
:root {
  --primary-color: #1890ff;
  --primary-color-dark: #438f90;
  --light-gray: #f9f9f9;
  --medium-gray: #eee;
  --dark-gray: #303030;
  --text-color-dark: #333;
  --text-color-light: #fff;
  --text-color-medium: #666;
  --success-color: #5cb85c;
  --pending-color: #f0ad4e;
  --border-radius: 12px;
  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/*
 * CHECKOUT PAGE LAYOUT
 * Sets the main layout for the checkout page.
 */
.checkout-page {
    max-width: 100%;
    padding: 1px 20px;
    margin: 80px 10px;
    font-family: 'Segoe UI', sans-serif;
    min-height: 100vh;
    justify-items: center;
    align-items: center;
}

.checkout-page h1 {
    font-size: 1.5rem;
    text-align: center;
    margin: 40px;
    color: white;
    font-family: 'GlitchGoblin', sans-serif;
}

.checkout-container {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
}

.checkout-container h2 {
    color: var(--text-color-dark);
}

.checkout-price {
    color: #007bff;
    font-weight: 600;
}

.checkout-price2 {
    color: #007bff;
    font-weight: 600;
    margin: 0px 0px;
}

.final-price {
    color: #007bff;
    font-weight: 700;
    font-size: 1.5rem;
}

.checkout-qty {
    color: #888;
}

.checkout-duration {
    color: var(--text-color-dark);
}

.order-summary,
.checkout-confirmation {
    flex: 1 1;
    min-width: 390px;
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.checkout-item {
    display: flex;
    margin-bottom: 2rem;
    border-bottom: 1px solid #eee;
    padding: 1rem;
    background-color: #eeeeee;
    border-radius: 10px;
}

.checkout-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 1rem;
}

.checkout-details h4 {
    margin: 0 0 0.3rem 0;
    font-size: 1rem;
    color: var(--text-color-dark);
}

.place-order-btn {
    width: 100%;
    padding: 1rem;
    font-size: 1.1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.place-order-btn:hover {
    background-color: #0056b3;
}

.summary-total {
    margin-top: 1rem;
    text-align: right;
    font-weight: bold;
}

.summary-total h3 {
    color: #007bff;
}

.confirmation-note {
    font-size: 1rem;
    color: var(--text-color-dark);
    margin-bottom: 1.5rem;
}

.payment-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem 0 2rem;
}

.payment-option {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    border: 2px solid #ddd;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fafafa;
}

.payment-option img {
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.payment-option span {
    font-size: 1rem;
    font-weight: 500;
    color: #333;
}

.payment-option.selected {
    border-color: #007bff;
    background-color: #e6f0ff;
}

.fee-text {
    font-size: 0.85rem;
    color: #888;
    margin-top: 2px;
}

.final-total-bar {
    font-size: 1.1rem;
    font-weight: 600;
    text-align: right;
    margin-top: 1rem;
    padding: 0.75rem 0;
    border-top: 1px solid #ccc;
    color: var(--text-color-dark);
}

/* Add these styles to your existing CSS */
.payment-option.unavailable {
    opacity: 0.6;
    cursor: not-allowed;
    position: relative;
}

.payment-option.unavailable:hover {
    background-color: inherit;
}

.unavailable-badge {
    background-color: #ff3333;
    color: white;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 8px;
}



@media (max-width: 768px) {
    .checkout-page h1 {
        font-size: 23px;
        margin: 0px;
        padding: 0px;
    }
    
    .checkout-container {
        margin: 20px 0px;
    }
    
    .checkout-page {
        padding: 2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/CheckoutPage.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;;;EAGE;AACF;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;IACnC,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA,0CAA0C;AAC1C;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;;;AAIA;IACI;QACI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/*\n * ROOT VARIABLES\n * Define common values for easy maintenance.\n */\n:root {\n  --primary-color: #1890ff;\n  --primary-color-dark: #438f90;\n  --light-gray: #f9f9f9;\n  --medium-gray: #eee;\n  --dark-gray: #303030;\n  --text-color-dark: #333;\n  --text-color-light: #fff;\n  --text-color-medium: #666;\n  --success-color: #5cb85c;\n  --pending-color: #f0ad4e;\n  --border-radius: 12px;\n  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);\n  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/*\n * CHECKOUT PAGE LAYOUT\n * Sets the main layout for the checkout page.\n */\n.checkout-page {\n    max-width: 100%;\n    padding: 1px 20px;\n    margin: 80px 10px;\n    font-family: 'Segoe UI', sans-serif;\n    min-height: 100vh;\n    justify-items: center;\n    align-items: center;\n}\n\n.checkout-page h1 {\n    font-size: 1.5rem;\n    text-align: center;\n    margin: 40px;\n    color: white;\n    font-family: 'GlitchGoblin', sans-serif;\n}\n\n.checkout-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2rem;\n}\n\n.checkout-container h2 {\n    color: var(--text-color-dark);\n}\n\n.checkout-price {\n    color: #007bff;\n    font-weight: 600;\n}\n\n.checkout-price2 {\n    color: #007bff;\n    font-weight: 600;\n    margin: 0px 0px;\n}\n\n.final-price {\n    color: #007bff;\n    font-weight: 700;\n    font-size: 1.5rem;\n}\n\n.checkout-qty {\n    color: #888;\n}\n\n.checkout-duration {\n    color: var(--text-color-dark);\n}\n\n.order-summary,\n.checkout-confirmation {\n    flex: 1;\n    min-width: 390px;\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.checkout-item {\n    display: flex;\n    margin-bottom: 2rem;\n    border-bottom: 1px solid #eee;\n    padding: 1rem;\n    background-color: #eeeeee;\n    border-radius: 10px;\n}\n\n.checkout-image {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    border-radius: 8px;\n    margin-right: 1rem;\n}\n\n.checkout-details h4 {\n    margin: 0 0 0.3rem 0;\n    font-size: 1rem;\n    color: var(--text-color-dark);\n}\n\n.place-order-btn {\n    width: 100%;\n    padding: 1rem;\n    font-size: 1.1rem;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.place-order-btn:hover {\n    background-color: #0056b3;\n}\n\n.summary-total {\n    margin-top: 1rem;\n    text-align: right;\n    font-weight: bold;\n}\n\n.summary-total h3 {\n    color: #007bff;\n}\n\n.confirmation-note {\n    font-size: 1rem;\n    color: var(--text-color-dark);\n    margin-bottom: 1.5rem;\n}\n\n.payment-options {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem 0 2rem;\n}\n\n.payment-option {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.75rem 1rem;\n    border: 2px solid #ddd;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background: #fafafa;\n}\n\n.payment-option img {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n}\n\n.payment-option span {\n    font-size: 1rem;\n    font-weight: 500;\n    color: #333;\n}\n\n.payment-option.selected {\n    border-color: #007bff;\n    background-color: #e6f0ff;\n}\n\n.fee-text {\n    font-size: 0.85rem;\n    color: #888;\n    margin-top: 2px;\n}\n\n.final-total-bar {\n    font-size: 1.1rem;\n    font-weight: 600;\n    text-align: right;\n    margin-top: 1rem;\n    padding: 0.75rem 0;\n    border-top: 1px solid #ccc;\n    color: var(--text-color-dark);\n}\n\n/* Add these styles to your existing CSS */\n.payment-option.unavailable {\n    opacity: 0.6;\n    cursor: not-allowed;\n    position: relative;\n}\n\n.payment-option.unavailable:hover {\n    background-color: inherit;\n}\n\n.unavailable-badge {\n    background-color: #ff3333;\n    color: white;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-left: 8px;\n}\n\n\n\n@media (max-width: 768px) {\n    .checkout-page h1 {\n        font-size: 23px;\n        margin: 0px;\n        padding: 0px;\n    }\n    \n    .checkout-container {\n        margin: 20px 0px;\n    }\n    \n    .checkout-page {\n        padding: 2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
